/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_DimensionsInputs */

const en_directory_agent_readiness_dimensions = /** @type {(inputs: Directory_Agent_Readiness_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readiness dimensions`)
};

const zh_directory_agent_readiness_dimensions = /** @type {(inputs: Directory_Agent_Readiness_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`就绪度维度`)
};

/**
* | output |
* | --- |
* | "Readiness dimensions" |
*
* @param {Directory_Agent_Readiness_DimensionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_dimensions = /** @type {((inputs?: Directory_Agent_Readiness_DimensionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_DimensionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_dimensions(inputs)
	return zh_directory_agent_readiness_dimensions(inputs)
});
export { directory_agent_readiness_dimensions as "directory.agent_readiness.dimensions" }